export var PeerRoles;
(function (PeerRoles) {
    PeerRoles["SIMPLE"] = "simple";
    PeerRoles["CANDIDATE"] = "candidate";
    PeerRoles["SUPER_NODE"] = "super-node";
})(PeerRoles || (PeerRoles = {}));
